import React from 'react'
import { Button } from '@mantine/core'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'
import toast from 'react-hot-toast'

export default function EffortGenerateDashboardButton({ text = "Generate Dashboard", reqData = {}, onSuccess = () => { } }) {
  const { mutate, isPending } = useMutation({
    mutationFn: () => axios.post('/admin-set-campaign-effort-data/', reqData),
    onSuccess: () => {
      toast.success('Dashboard generated')
      onSuccess()
    },
    onError: (error) => {
      toast.error(error)
    }
  });

  return (
    <Button size="xs" color="gray" variant="light" onClick={() => mutate()} loading={isPending}>{text}</Button>
  )
}
